import { useEffect, useState } from "react";

import MaterialService from "../api/MaterialService";
import { MinimalProduct } from "../types/product";
import { formatServiceData } from "../utils/formatServiseData";
import { fromEventMaterials } from "../utils/materials";

// The materials used in one monitor event. The event itself only carries the SevDesk materials
// stored on it the old way; the job's material list has all of them, web materials included.
export const useEventMaterials = (event: any): MinimalProduct[] => {
  const [materials, setMaterials] = useState<MinimalProduct[] | null>(null);

  const jobId = event?.data?.jobId;
  const eventId = event?.data?.id;

  useEffect(() => {
    if (!jobId || !eventId) {
      return;
    }

    let cancelled = false;

    MaterialService.GetMaterialsByJobId(jobId)
      .then((response) => {
        if (!cancelled) {
          setMaterials(fromEventMaterials(response.data ?? [], eventId));
        }
      })
      .catch((error) => console.log(error));

    return () => {
      cancelled = true;
    };
  }, [jobId, eventId]);

  return materials ?? formatServiceData(event).products;
};
